var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
var BlueButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: black;\n  background-color: blue;\n"], ["\n  color: black;\n  background-color: blue;\n"])));
export var Button = function () {
    return React.createElement(BlueButton, null, "Button");
};
var templateObject_1;
//# sourceMappingURL=Button.js.map